import { ROUTES_NAMES } from '@/constants';
import { RouteRecordRaw } from 'vue-router';

const notFoundRoute: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  redirect: { name: ROUTES_NAMES.login }
};

export default notFoundRoute;
